import React, { useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { DrawingManager, GoogleMap, Data, useJsApiLoader, Polygon } from "@react-google-maps/api";
import "./index.css";
import {
  AddMonitoringOrdersBounding,
  SetDriverPopUp,
  SetOrderPinPopUp,
  SetOrderPinPopUpPosition,
  SetSelectedMonitoringDriver,
  SetSelectedMonitoringOrder,
  Set_latlng,
  Set_Map_Ref,
  Set_map_loaded,
} from "../../../../Redux/actions/actionNames";
import BoundGenerater from "./boundGenerater";
import DriverOrdersPinBounding from "./driverOrdersPinBounding";
import { getCenterMap } from "../../../../helper/module";
import styles from '../style.module.css';
import IconProvider from "../../../../design-system/lib/IconProvider";
import { INFO_CIRCLE, Speaker } from "../../../../assets";
import Typography from "../../../../design-system/lib/Typography";
import wkx from "wkx";
import buffer from "buffer";
import * as R from "ramda";
import { dropAndReturnElementById, dropAndReturnLastElement, processOnVertexOrEdgeClick } from "../utils";

var _ = require("lodash");
 
export const DefaultPolygonOptions = {
  borderColor: "blue",
  backgroundColor: "blue",
  borderWidth: 1,
};

const customStyle = [ 
];

const lib = ["drawing" ]


const App = (props) => {
  const [polygons, setPolygons] = React.useState([]);
    const drawingRef = React.useRef(null);
  const zoom = useSelector((state) => state.Map.zoom);

   const [loaded, setloaded] = useState(false);
  const [finishedmoving, setfinishedmoving] = useState(false);
  const [Driverselected, setDriverselected] = useState(null);
  const ref = useRef(null);
  const dispatch = useDispatch();
  const mapLoaded = useSelector((state) => state.Map.loaded);
  const FavAddressOpenDialoge = useSelector((state) => state.FavAddress.openDialoge);
  const OpenNRDialoge = useSelector((state) => state.NewOrder.OpenDialoge);
  const NRactivePickupDropOff = useSelector((state) => state.NewOrder.newOrder.activePickupDropOff);
  const NRpickupAddress = useSelector((state) => state.NewOrder.newOrder.pickup.address);
  const NRpickupAdresss_loc = useSelector((state) => state.NewOrder.newOrder.pickup.adresss_loc);
  const NRdropOffAddress = useSelector((state) => state.NewOrder.newOrder.dropOffs.firstDropOff.address);
  const NRdropOffsAdresss_loc = useSelector((state) => state.NewOrder.newOrder.dropOffs.firstDropOff.adresss_loc);
  const NRotherDropOffs = useSelector((state) =>  state.NewOrder.newOrder.dropOffs.otherDropOffs);
  const Globalsettings = useSelector((state) => state.SharedData.settings);
  const OpenVRDialoge = useSelector((state) => state.ViewTravel.OpenDialoge);
  const VRpureData = useSelector((state) => state.ViewTravel.pureData);
  const EROpenERDialoge = useSelector((state) => state.EditOrder.OpenDialoge);
  const ERactivePickupDropOff = useSelector((state) => state.EditOrder.editOrder.activePickupDropOff);
  const ERpickupAddress = useSelector((state) => state.EditOrder.editOrder.pickup.address);
  const ERpickupAdresss_loc = useSelector((state) => state.EditOrder.editOrder.pickup.adresss_loc);
  const ERdropOffAddress = useSelector((state) => state.EditOrder.editOrder.dropOffs.firstDropOff.address);
  const ERdropOffsAdresss_loc = useSelector((state) => state.EditOrder.editOrder.dropOffs.firstDropOff.adresss_loc);
  const ERotherDropOffs = useSelector((state) => state.EditOrder.editOrder.dropOffs.otherDropOffs);
  const center = useSelector((state) => state.Map.center);
  const showEventTimeLine = useSelector((state) => state.ViewTravel.eventTimeLine.show);
  const googleMapLoaded = useSelector((state) =>  state.SharedData.googleMapLoaded);
  const orderType = useSelector((state) => state.ViewTravel.pureData
  ? state.ViewTravel.pureData.type
    ? state.ViewTravel.pureData.type
    : null
  : null,);
  const loading = useSelector((state) => state.ViewTravel.loading);
  const error = useSelector((state) => state.ViewTravel.error);
  const mapRef = useSelector((state) => state.Map.mapRef);
  const MonitoringOrdersOpen = useSelector((state) => state.Monitoring.orders.open);
  const ordersBoundingList = useSelector((state) => state.Monitoring.ordersBoundingList);
  const ordersBoundingDriver = useSelector((state) => state.Monitoring.ordersBoundingDriver);

  const mapOnClick = () => {
    // dispatch(SetSelectedMonitoringOrder(null))
    // dispatch(SetSelectedMonitoringDriver(null))
    // dispatch(SetDriverPopUp(null))
    // dispatch(SetOrderPinPopUp(null))
    // dispatch(SetOrderPinPopUpPosition(null))
  };

  const handleonZoomChanged = React.useCallback((e) => {
     const map = mapRef;

     console.log("handleonZoomChanged" , map)
 try {
     if (map) {
        dispatch({ type: "mapSetZoom", state: map.getZoom() })
       dispatch({ type: "mapSetBounds", state: map.getBounds() || undefined })
     }
 } catch (error) {
  
 }
  }, [mapRef]);

  const handleonBoundChanged = React.useCallback(() => {
    const map = mapRef;
try {
      if (map) {
       dispatch({ type: "mapSetBounds", state: map.getBounds() || undefined })    }
} catch (error) {
  
}

  }, [mapRef]);

      const resetDrawingToolsMode = () => {
      drawingRef.current?.state.drawingManager?.setDrawingMode(null);
    };

  const handleCenterChanged = () => {
    if (ref) {
      const newCenter = getCenterMap(mapRef, center);
      // onCenterChange(newCenter);
    }
  };

  const handleOnLoad = (map) => {
    dispatch(Set_Map_Ref(map));
  
    // setState({
    //   ref:map
    // })
    // setState({ref:map})
  };

  const { isLoaded } = useJsApiLoader({
    libraries: lib,
    id: 'google-map-script',
    googleMapsApiKey:  global.config.dispatcherSettings.applicationMap.apiKey 
  })


  const onLoad = (data) => {
    console.log("data: ", data);
  };


  function buf2hex(buffer) {
    // buffer is an ArrayBuffer
    return [...new Uint8Array(buffer)]
      .map((x) => x.toString(16).padStart(2, "0"))
      .join("");
  }

    function isMapPickupDelivery( ) {
   const path = window.location.pathname;

  // لیست مسیرهای مجاز (true) یا بستن منو
 
  // اگر مسیر ناوبری با "/PickupDelivery" یا زیرمسیرهای آن آغاز می‌شود، false بده
  if ( path.startsWith("/PickupDelivery/map")) {
    return true;
  }else{
    return false
  }

  }


   return (
      <div className={props.className} style={{ ...props.style , position:"relative" ,width :"100%" ,height: isMapPickupDelivery() ? `calc(100%)` :"calc(100% - 44px)" }} id="googlemapUniqeId">
        {(Globalsettings && Globalsettings.dispatcherHomeMessage && String(Globalsettings.dispatcherHomeMessage).length > 0 && ( String(window.location.pathname).includes("/Ondemand") || String(window.location.pathname).includes("/neworder"))) && <div className={styles.helloMessageContainer}>
          <IconProvider Icon={Speaker} />
          <Typography weight="Body_Middle_Regular" textColor="TextDark" text={Globalsettings.dispatcherHomeMessage} />
        </div>}

        {/* {!mapLoaded && <LoadScript
          loadingElement={<></>} onError={(e) => { dispatch(Set_map_loaded(true)); setState({ loaded: false }) }} onLoad={() => { dispatch(Set_map_loaded(true)); setState({ loaded: true }) }}
          googleMapsApiKey={global.config.dispatcherSettings.applicationMap.apiKey}>



        </LoadScript>} */}

        {isLoaded  && <GoogleMap
          options={{
            fullscreenControl: false,
            linksControl: false,
            panControl: false,
           addressControl: false,
           enableCloseButton: false,
           zoomControl: false,
           enableCloseButton: false,

           styles: [ ],
  clickableIcons: false, // ⛔ مهم: غیرفعال کردن کلیک روی آیکون‌های POI
  streetViewControl: false,

           gestureHandling: "greedy",
         }}
         id="map"
          mapContainerStyle={{
            width: "100%",
            height: "100%",
          }}
          style={{
            width: "100%",
            height: "100%",
          }}
          onLoad={handleOnLoad}
          center={center}
          zoom={zoom}
          onDragEnd={handleCenterChanged}
          onResize={handleCenterChanged}
          onZoomChanged={handleonZoomChanged}
         onBoundsChanged={handleonBoundChanged}
           onClick={mapOnClick}
        >
          {props.children}
          {mapRef &&
            (!_.isEmpty(VRpureData) || isNewOrder()) && (
              <BoundGenerater />
            )}
          {mapRef && _.isEmpty(VRpureData) && (
            <DriverOrdersPinBounding />
          )}


         {/* <DrawingManager
                     ref={drawingRef}

           onLoad={onLoad}
          //  onPolygonComplete={onPolygonComplete}
               onOverlayComplete={(evt) => {
              const { type, overlay } = evt;

              if (overlay) {
                window.google.maps.event.clearInstanceListeners(overlay);
                overlay.setMap(null);

               if (type == "polygon") {
                  const typedOverlay = overlay ;
                  const coordinateFuncs  = typedOverlay
                    .getPath()
                    .getArray();

                  const coordinates =
                    coordinateFuncsToCoordinates(coordinateFuncs);

                  if (coordinates.length < 3) {
                    return;
                  }

                  setPolygons((prevPolygons) => [
                    ...prevPolygons,
                    {
                      id: R.inc(polygons.length),
                      coordinates,
                      options: DefaultPolygonOptions,
                      prevCoordinates: [],
                      polygonInstance: null,
                    },
                  ]);

                  resetDrawingToolsMode();

                  return;
                }
 
              }
            }}
           options={{
             drawingControl: true,
             polygonOptions: {
               strokeWeight: 5,
               fillOpacity: 0.3,

               suppressUndo: true,
             },
           }}
         />



          {polygons.map((polygon) => (
            <Polygon
              key={polygon.id}
              editable
              draggable
              paths={polygon.coordinates}
              
 
            />
          ))}  */}

        </GoogleMap>}
      </div>
    );
};

function isNewOrder() {
  if (String(window.location.href).includes("neworder")) {
    return true
  } else {
    return false
  }
}

export default App


 const coordinateFuncsToCoordinates = (
  coordinates ) =>
  coordinates.map(({ lat, lng }) => ({
    lat: lat(),
    lng: lng(),
  }));

 